import { useCallback, useEffect } from "react";
import { Vibration, View } from "react-native";
import styles from "../Styles.jsx";
import { useGeo } from "../contexts/GeoContext.js";
import { useJourney } from "../contexts/JourneyContext.js";
import GraphicBackground from "../elements/GraphicBackground.jsx";
import LoadingSpinner from "../elements/LoadingSpinner.jsx";
import Toolbar from "../elements/Toolbar.js";
import ScreenCaptions from "./ScreenCaptions.jsx";
import ScreenClues from "./ScreenClues.jsx";

export default function ScreenLocationHunt(props) {

  const journey = useJourney();
  const geo = useGeo();
  
  const coords = geo.coordinates;

  const location = props.location || journey.selectedLocation;
  //console.log("ScreenLocationHunt: location =", location);
  const showingAtLocation = journey.showingAtLocation; // Use state from JourneyContext

  let distance = geo.distanceToLocation(location);

  // Set starting distance when location prop is provided (e.g., for Prelude/Finale)
  useEffect(() => {
    if (props.location && coords && coords.latitude && coords.longitude) {
      const initialDistance = geo.distanceToLocation(props.location);
      if (initialDistance !== null && journey.startingDistance === null) {
        console.log("Setting starting distance for prop-based location:", initialDistance);
        journey.setStartingDistance(initialDistance);
      }
    }
  }, [props.location, coords, geo, journey]);

  const markArrivedAtLocation = useCallback(() => {
    //console.log("Marking arrived at location:", location);
    Vibration.vibrate();
    journey.arrivedAtLocation(location); // This now handles setting showingAtLocation to true
  }, [journey, location]);

  useEffect(() => {
    //console.log("Location Hunt Screen: useEffect - coords or distance changed", coords, distance);
    // console.log("Location data:", location);
    // console.log("Is within range:", geo.isWithinLocationRange(location));
    
    if (location && coords && coords.latitude && coords.longitude) {
      if (!showingAtLocation && geo.isWithinLocationRange(location)) {
        console.log("🎯 Arrived at location! Switching to captions.");
        markArrivedAtLocation();
      } else {
        //console.log("📍 Not yet within range. Distance:", distance, "Required radius:", location?.radius);
      }
    } else {
      console.log("❌ Missing data - location:", !!location, "coords:", !!coords, "lat/lng:", coords?.latitude, coords?.longitude);
    }
  }, [coords, distance, location, geo, markArrivedAtLocation, showingAtLocation]);

  const finishedHunt = () => {
    
    if (props.onComplete) {
      props.onComplete();
    }
  };


  if (!location) {
    return (
      <View style={styles.centerContainer}>
        <LoadingSpinner />
      </View>
    );
  }
  return (
    <GraphicBackground source={location.backgroundimagefilename} fadeIn={true}>
      {!showingAtLocation && (
        <ScreenClues location={location}
          onComplete={markArrivedAtLocation}
        />
      )}
      {showingAtLocation && (
        <ScreenCaptions location={location} onComplete={finishedHunt} />
      )}
      <Toolbar />
    </GraphicBackground>
  );
}